module.exports = __webpack_public_path__ + "img/bx-code.a006c77e.svg";